<article class="container">
	<section class="modal-header">
		<p class="title">Cancelar Voucher</p>
		<mat-icon
			svgIcon="pm-icons:close"
			style="width: 14px; height: 14px"
			(click)="closeModal()"
		></mat-icon>
	</section>

	<div class="modal-content">
		<p>Tem certeza que deseja cancelar o Voucher?</p>

		<p><span>Usuário:</span> {{ voucher.clientName }}</p>
		<p><span>Data início:</span> {{ voucher.validFrom | date: 'dd/MM/yyy' }}</p>
		<p><span>Data final:</span> {{ voucher.validUntil | date: 'dd/MM/yyy' }}</p>
		<p><span>Valor:</span> {{ voucher.value | currency: 'BRL' }}</p>
	</div>

	<section class="modal-footer">
		<button mat-raised-button (click)="closeModal()">Sair</button>
		<button mat-raised-button color="primary" (click)="cancelVoucher()">Cancelar</button>
	</section>
</article>
